import { useEffect, useState } from "react";
import "./universities.scss";
import store from "../../../controllers/store";
import { findById } from "../../../controllers/store/actions/universities/get-university-actions";
import { useSelector } from "react-redux";
import {
  Card,
  Row,
  Col,
  Button,
  Typography,
  Avatar,
  Skeleton,
  Empty,
  notification,
} from "antd";
import { capitalizeString, getCityNameByCode } from "../../../shared/util";
import Moment from "react-moment";
import { useNavigate, useParams } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import {
  Contact,
  DataItem,
  PageSetting,
  RecordStatus,
  RequestStatus,
  routerData,
} from "../..";
import result from "antd/es/result";
import RecomendationList from "../../components/Recomedations";
import useRecomendations from "../../../hooks/recomendations-entities-hook";
import { saveRequest, sendNotification } from "../../../controllers/connection";
import { getSended } from "../../../controllers/store/actions/connection/connection-sended-actions";
import { RequestConnection } from "../../../models/RequestConnection";
import ConnectionRequest from "../../components/Forms/Modal/ConnectionRequest/Connection-Request";
const { Paragraph } = Typography;
type NotificationType = "success" | "info" | "warning" | "error";

const dispatch = store.dispatch;
const UniversitiesDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const UniversityState = useSelector((state: any) => state.university);
  const { result, getRecomendations } = useRecomendations();
  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contact, setContact] = useState<Contact>();
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  const openNotificationWithIcon = (type: NotificationType) => {
    api[type]({
      message: "UNAB",
      description: "Solicitud enviada correctamente.",
    });
  };

  const go = (params: routerData, entity: any) => {
    navigate(`/${entity}/${params.id}`, { state: { params, entity } });
  };

  useEffect(() => {
    if (id) {
      dispatch(findById(id));
    }
    getRecomendations("all", { filter: "" }, 1, 4);
  }, []);

  return (
    <div style={{ width: "100%", height: "max-content" }}>
      <div>
        <ConnectionRequest
          open={isModalOpen}
          onOk={(value: any, text: string) => {
            const request = new RequestConnection(
              "",
              text,
              user.me,
              {
                name: contact?.name || "",
                email: contact?.email || "",
                organization_name:
                  contact?.organization_name || contact?.name || "",
                type: contact?.type || "",
              },
              RequestStatus.Pending,
              value.requestType || "",
              contact?.type
            );

            saveRequest(request);
            sendNotification(request);
            setIsModalOpen(false);
            openNotificationWithIcon("success");
            dispatch(
              getSended(
                "connection_request",
                {
                  meta: "filter_count",
                  filter: `&filter[user_created][id][_eq]=${user.me.id}&filter[status][_eq]=${RecordStatus.Active}`,
                },
                1,
                10
              )
            );
          }}
          onCancel={() => setIsModalOpen(false)}
          contact={{
            name: contact?.name || "",
            email: contact?.email || "",
            organization_name: contact?.organization_name || "",
            type: contact?.type || "",
          }}
        />
        <Skeleton
          loading={UniversityState.isLoading}
          active
          className="full-width"
        >
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={12} md={8} lg={16}>
              <h1 className="conection-heading-section">Datos generales</h1>
              <Card
                className="ant-card-conection ant-card-conection-bordered"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Nombre</h2>
                    <p className="conection-value">
                      {capitalizeString(
                        UniversityState.university?.institution_name
                      )}
                    </p>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Descripción</h2>
                    <p className="conection-value text-justify">
                      {capitalizeString(
                        UniversityState.university?.description || "No definino"
                      )}
                    </p>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Departamento</h2>
                    <p className="conection-value">
                      {getCityNameByCode(UniversityState.university?.city)
                        ?.departamento || UniversityState?.university?.cityRaw}
                    </p>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Ciudad</h2>
                    <p className="conection-value">
                      {getCityNameByCode(UniversityState?.university?.city)
                        ?.municipio || UniversityState?.university?.stateRaw}
                    </p>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Institución acreditada?</h2>
                    <p className="conection-value">
                      {UniversityState.university?.is_accredited === 1
                        ? "Si"
                        : "No"}
                    </p>
                  </Col>
                  {UniversityState.university?.recognized_min ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">
                        Reconociento Minciencias
                      </h2>
                      <p className="conection-value">
                        {capitalizeString(
                          UniversityState.university?.recognized_min
                            ? "Si"
                            : "No"
                        )}
                      </p>
                    </Col>
                  ) : null}

                  {UniversityState.university?.issue_date ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Fecha de expedición</h2>
                      <p className="conection-value">
                        {UniversityState.university?.issue_date || "N/A"}
                      </p>
                    </Col>
                  ) : null}
                  {UniversityState.university?.current_date ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Vigencia</h2>
                      <p className="conection-value">
                        {UniversityState.university?.current_date || "N/A"}
                      </p>
                    </Col>
                  ) : null}
                  {UniversityState.university?.update_date ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Última Actualización</h2>
                      <p className="conection-value">
                        {UniversityState.university?.update_date || "N/A"}
                      </p>
                    </Col>
                  ) : null}
                  {UniversityState.university?.source ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Fuente</h2>
                      <p className="conection-value">
                        {UniversityState.university?.source}
                      </p>
                    </Col>
                  ) : null}
                  {UniversityState.university?.recognized_min ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">
                        Reconociento Minciencias (Sí/No){" "}
                      </h2>
                      <p className="conection-value">
                        {UniversityState.university?.recognized_min === 1
                          ? "Si"
                          : "No"}
                      </p>
                    </Col>
                  ) : null}
                  {UniversityState.university?.features ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Características</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          UniversityState.university?.features || "sin definir"
                        )}
                      </p>
                    </Col>
                  ) : null}

                  {UniversityState.university?.url ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">URL</h2>
                      {UniversityState.university?.url ? (
                        <Button
                          type="primary"
                          onClick={() => {
                            if (
                              UniversityState.university?.url.match("http")
                                ?.length > 0
                            ) {
                              window.open(
                                UniversityState.university?.url,
                                "_blank"
                              );
                            } else {
                              window.open(
                                `https://${UniversityState.university?.url}`,
                                "_blank"
                              );
                            }

                            window.open(
                              UniversityState.university?.url,
                              "_blank"
                            );
                          }}
                        >
                          Abrir URL
                        </Button>
                      ) : (
                        "Sin url"
                      )}
                    </Col>
                  ) : null}
                </Row>
              </Card>
              <>
                <h1 className="conection-heading-section">Grupos</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row gutter={[8, 8]} className="full-width">
                    <Col xs={24} sm={12} md={8} lg={24}>
                      {!UniversityState?.university?.groups ||
                      UniversityState?.university?.groups?.length === 0 ? (
                        <Empty description={"0 Registros"} />
                      ) : null}
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {UniversityState.university?.groups?.map((g: any) => {
                      console.log("g", g);
                      return (
                        <Col xs={24} sm={12} md={8} lg={12}>
                          <Button
                            className="connection-font"
                            size="middle"
                            style={{
                              overflow: "hidden",
                              whiteSpace: "normal",
                              textOverflow: "ellipsis",
                              marginRight: 20,
                              width: "auto",
                              marginBottom: 10,
                            }}
                            onClick={() => {
                              go(
                                {
                                  id: g.groups_id.id,
                                  name: g.groups_id.nme_grupo_gr,
                                  type: g.groups_id.actor_type.actor,
                                },
                                "groups"
                              );
                            }}
                          >
                            {capitalizeString(g.groups_id?.nme_grupo_gr)}
                          </Button>
                        </Col>
                      );
                    })}
                  </Row>
                </Card>
              </>
              <>
                <h1 className="conection-heading-section">Investigadores</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row gutter={[8, 8]} className="full-width">
                    <Col xs={24} sm={12} md={8} lg={24}>
                      {!UniversityState.university?.searchers ||
                      UniversityState?.university?.searchers?.length === 0 ? (
                        <Empty description={"0 Registros"} />
                      ) : null}
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    {UniversityState?.university?.searchers?.map((s: any) => (
                      <Col lg={12} key={s.id}>
                        <div
                          onClick={() => {
                            go(
                              {
                                id: s.searchers_id.id,
                                name: s.searchers_id.nombre,
                                type: s.searchers_id.actor_type.actor,
                              },
                              "searchers"
                            );
                          }}
                          style={{ marginBottom: 20 }}
                          className="flex with-pointer"
                        >
                          <Avatar icon={<UserOutlined />} />
                          <p className="profile-info">
                            {`${s?.searchers_id?.nombre}` || ""}
                            <span>
                              {`${s?.searchers_id?.nme_niv_form_pr}` || ""}
                            </span>
                          </p>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <Row />
                </Card>
              </>
            </Col>
            {user?.me ? (
              <Col xs={24} sm={12} md={8} lg={8}>
                <h1 className="conection-heading-section">Sugerencias</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Skeleton
                    loading={result.loading}
                    active
                    className="full-width"
                  >
                    <RecomendationList
                      totalPages={result.pagination?.total}
                      onPaginationChanged={(page) => {
                        getRecomendations("all", { filter: {} }, page, 5);
                        setPage(page);
                      }}
                      onConnect={(contact) => {
                        setContact({
                          name: contact.title,
                          type: contact.description,
                          email: contact.contact_email,
                        });
                        setIsModalOpen(!isModalOpen);
                      }}
                      data={result.values
                        .filter((r) => r.id !== id)
                        .map((recomendation: any) => {
                          return {
                            title: recomendation.name,
                            description: `${recomendation.type.actor} - ${
                              recomendation.city || recomendation.cityRaw || ""
                            }`,
                            avatar: "",
                            contact_email: recomendation.contact_email,
                          } as DataItem;
                        })}
                    />
                  </Skeleton>
                </Card>
              </Col>
            ) : null}
          </Row>
        </Skeleton>
      </div>
    </div>
  );
};

export default UniversitiesDetail;
